export default __webpack_public_path__ + "static/media/logo-frexco.5660ce07.svg";